@let defaultEmptyText = "emptyText" | t;
<div class="user-select-field">
    @if (label) {
        <div class="label-container">
            <cerrix-label [for]="name">{{ label }}</cerrix-label>
            @if (infoText) {
                <cerrix-instructions-icon
                    class="input-instructions-icon"
                    [instructionText]="infoText"
                    [showText]="false"
                ></cerrix-instructions-icon>
            }
            @if (readonly && editIcon) {
                <cerrix-icon-button
                    [attr.data-uiid]="name + '-edit-button'"
                    [icon]="editIcon"
                    [ariaLabel]="'editLabel' | t"
                    buttonSize="small"
                    [showBorder]="false"
                    (click)="editRequested.emit()"
                />
            }
        </div>
    }
    <div class="user-select-trigger" validationErrors [attr.name]="name">
        <app-cerrix-avatar-group
            [attr.data-uiid]="name + '-avatar-group'"
            [names]="selectedNames"
            [showAddButton]="!readonly"
            [addLabel]="dialogTitle"
            [emptyText]="emptyText ?? defaultEmptyText"
            (addRequested)="openDialog()"
        ></app-cerrix-avatar-group>
    </div>
</div>

<cerrix-dialog [name]="dialogName" [attr.data-uiid]="dialogName" (closed)="onDialogClosed()">
    <div header-title>{{ dialogTitle }}</div>
    <div class="user-select-dialog-content" dialog-content>
        @if (dialogOpen) {
            <app-cerrix-user-type-picker
                [name]="name"
                [types]="types"
                [(value)]="draft"
                [readonly]="readonly"
            ></app-cerrix-user-type-picker>
        }
    </div>
    <div class="user-select-dialog-footer" dialog-footer>
        <cerrix-button
            buttonType="secondary"
            secondaryColor="filled"
            buttonSize="big"
            [attr.data-uiid]="name + '-cancel'"
            (click)="cancel()"
            >{{ cancelText ?? ("cancel" | t) }}</cerrix-button
        >
        @if (!readonly) {
            <cerrix-button
                buttonSize="big"
                primaryColor="green"
                [attr.data-uiid]="name + '-confirm'"
                (click)="confirm()"
                >{{ confirmText ?? ("confirm" | t) }}</cerrix-button
            >
        }
    </div>
</cerrix-dialog>
